const makeInitialState = data => ({
  adjustment: data ? data.adjustment : 0,
  gracePeriod: data.gracePeriod
});

export default makeInitialState;
